// extracted by mini-css-extract-plugin
export default {"tooltip":"ErrorAdornment_tooltip__c5AaY"};